import React from 'react';
import { BuyerChangeRequestStatus } from '@/types';
import { BaseStatusIndicatorProps } from '.';
import Indicator, { IndicatorColor } from '@/components/Indicator';
import { useLingui } from '@lingui/react';

interface ChangeRequestStatusIndicatorProps extends BaseStatusIndicatorProps {
    value: BuyerChangeRequestStatus;
}
const buyerColorMap: { [key in BuyerChangeRequestStatus]: IndicatorColor } = {
    RequestSent: 'warning',
    OfferReceived: 'warning',
    OfferAccepted: 'success',
    OfferRejected: 'danger',
    Closed: 'secondary',
};

const ChangeRequestStatusIndicator: React.FC<ChangeRequestStatusIndicatorProps> = ({ value, children, ...rest }) => {
    const { _ } = useLingui();

    return (
        <Indicator color={buyerColorMap[value]} {...rest}>
            {children || _({ id: `ChangeRequestStatusForBuyer.${value}` })}
        </Indicator>
    );
};

export default ChangeRequestStatusIndicator;
